import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationType, APPLICATION_TYPE_LABELS, ProjectFormData } from 'app/models/application';
import { ApplicationsService } from 'app/services/applications.service';
import { SessionStorage } from 'app/storage/session.storage';

@Component({
  selector: 'app-project-application-form',
  templateUrl: './project-application-form.component.html'
})
export class ProjectApplicationFormComponent implements OnInit {
  form!: FormGroup;
  submitting = false;
  errorMessage = '';
  serviceType!: ApplicationType;
  serviceLabel = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private applicationsService: ApplicationsService,
    private auth: SessionStorage,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.serviceType = this.route.snapshot.params['type'] as ApplicationType;
    this.serviceLabel = APPLICATION_TYPE_LABELS[this.serviceType] || this.serviceType;

    this.form = this.fb.group({
      project_acronym: ['', Validators.required],
      full_project_name: ['', Validators.required],
      funding_programme: ['', Validators.required],
      other_funding_programme: [''],
      grant_agreement: [''],
      project_short_description: ['', Validators.required],
      objectives_standardisation: ['', Validators.required],
      why_the_project_applying: ['', Validators.required],
      organisation: ['', Validators.required],
      country: ['', Validators.required],
      website_publication: [false],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    this.submitting = true;
    const formData: ProjectFormData = {
      ...this.form.value,
      topics: [],
      information_to_attain: [],
      standard_reference: [],
      related_doc_application: [],
    };
    this.applicationsService.create(this.auth.userId!, this.serviceType, formData).subscribe({
      next: () => this.router.navigate(['/my-applications']),
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Errore durante l\'invio. Riprova.';
        this.submitting = false;
      }
    });
  }
}
